import { useEffect, useRef, useState } from 'react';

const comics = [
  { title: '星辰之约', category: '恋爱/奇幻', rating: 9.8, reads: '1280万', cover: '/images/hot-comics/hot-1.webp', tag: '本周最热' },
  { title: '剑影风云', category: '热血/武侠', rating: 9.7, reads: '960万', cover: '/images/hot-comics/hot-2.webp', tag: '完结神作' },
  { title: '甜心食堂', category: '日常/治愈', rating: 9.6, reads: '820万', cover: '/images/hot-comics/hot-3.webp', tag: '治愈神作' },
  { title: '暗夜猎手', category: '悬疑/冒险', rating: 9.5, reads: '750万', cover: '/images/hot-comics/hot-4.webp', tag: '悬疑烧脑' },
  { title: '青春方程式', category: '校园/青春', rating: 9.4, reads: '690万', cover: '/images/hot-comics/hot-5.webp', tag: '校园必追' },
  { title: '异世界领主', category: '异世界/奇幻', rating: 9.6, reads: '880万', cover: '/images/hot-comics/hot-6.webp', tag: '异世界爽文' },
  { title: '机械之心', category: '科幻/机甲', rating: 9.3, reads: '520万', cover: '/images/hot-comics/hot-7.webp', tag: '科幻神作' },
  { title: '妖怪茶馆', category: '神怪/治愈', rating: 9.7, reads: '1100万', cover: '/images/hot-comics/hot-8.webp', tag: '国漫之光' },
];

const categories = ['全部', '恋爱', '热血', '日常', '悬疑', '校园', '异世界', '科幻', '神怪'];

function ScrollReveal({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.unobserve(el); } },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'} ${className}`}>
      {children}
    </div>
  );
}

export default function HotComics() {
  const [activeCategory, setActiveCategory] = useState('全部');

  const filtered = activeCategory === '全部'
    ? comics
    : comics.filter(c => c.category.includes(activeCategory));

  return (
    <div className="min-h-screen bg-pink-50/50 pt-20 relative overflow-hidden">
      {/* 网点纹理背景 */}
      <div className="absolute inset-0 halftone-pink pointer-events-none" />
      <div className="absolute inset-0 line-grid-neutral pointer-events-none" />

      <section className="relative px-4 md:px-8 lg:px-16 xl:px-24 py-20 md:py-28">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="text-center mb-14 md:mb-20">
              {/* 方框序号徽章 + eyebrow */}
              <div className="flex items-center justify-center gap-3 mb-5">
                <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg border-2 border-gray-900 bg-white font-serif text-sm font-bold text-pink-500 shadow-[3px_3px_0_0_#ff9db8]">
                  01
                </span>
                <span className="text-xs tracking-[0.25em] text-gray-500 font-medium uppercase">
                  Hot Ranking
                </span>
              </div>

              {/* 对话气泡标签 */}
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-lg border-2 border-gray-900 bg-white text-pink-600 text-sm font-bold shadow-[3px_3px_0_0_#ff9db8] mb-6 relative">
                热门推荐
                <span className="absolute -bottom-[7px] left-8 w-3 h-3 bg-white border-r-2 border-b-2 border-gray-900 rotate-45" />
              </div>

              <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight">
                热门漫画排行榜
                <span className="block mt-3 mx-auto w-28 h-1.5 bg-pink-400 rounded-full" />
              </h1>
              <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                天天漫画精选全网热门漫画，根据阅读量、评分和用户口碑综合排序。快来发现你的下一部追漫目标！
              </p>
            </div>
          </ScrollReveal>

          {/* Category Filter */}
          <ScrollReveal>
            <div className="flex flex-wrap justify-center gap-3 mb-12 md:mb-16">
              {categories.map((cat) => {
                const active = activeCategory === cat;
                return (
                  <button
                    key={cat}
                    onClick={() => setActiveCategory(cat)}
                    className={`px-5 py-2 rounded-lg border-2 border-gray-900 text-sm font-bold whitespace-nowrap transition-all duration-200 cursor-pointer ${
                      active
                        ? 'bg-pink-500 text-white shadow-[3px_3px_0_0_#1a1a1a]'
                        : 'bg-white text-gray-700 shadow-[3px_3px_0_0_#ff9db8] hover:bg-pink-50 hover:-translate-y-0.5'
                    }`}
                  >
                    {cat}
                  </button>
                );
              })}
            </div>
          </ScrollReveal>

          {/* Comics Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
            {filtered.map((comic) => {
              const rank = comics.indexOf(comic) + 1;
              return (
                <ScrollReveal key={comic.title}>
                  <div className="group cursor-pointer">
                    <div className="relative rounded-lg overflow-hidden border-2 border-gray-900 bg-white shadow-[5px_5px_0_0_#ff9db8] transition-all duration-200 group-hover:shadow-[5px_5px_0_0_#1a1a1a] group-hover:-translate-y-1.5">
                      {/* 封面 */}
                      <div className="relative aspect-[3/4] overflow-hidden border-b-2 border-gray-900">
                        <img
                          src={comic.cover}
                          alt={comic.title}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                        {/* 排名方框 */}
                        <div className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center border-2 border-gray-900 bg-gray-900 text-white font-serif font-bold text-base shadow-[2px_2px_0_0_#ff9db8]">
                          {rank}
                        </div>
                        {/* 标签 */}
                        <div className="absolute top-3 right-3 px-2.5 py-1 rounded border-2 border-gray-900 bg-pink-500 text-white text-[10px] font-bold shadow-[2px_2px_0_0_#1a1a1a]">
                          {comic.tag}
                        </div>
                        {/* hover 蒙层 */}
                        <div className="absolute inset-0 bg-gray-900/70 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center gap-2 p-4">
                          <span className="text-white text-sm font-bold flex items-center gap-1">
                            <i className="ri-star-fill text-amber-400" /> {comic.rating}
                          </span>
                          <span className="text-white/90 text-xs flex items-center gap-1">
                            <i className="ri-eye-line" /> {comic.reads} 阅读
                          </span>
                          <span className="mt-2 px-4 py-1.5 rounded-lg border-2 border-white bg-white text-gray-900 text-xs font-bold whitespace-nowrap">
                            立即阅读
                          </span>
                        </div>
                      </div>

                      {/* 信息区 */}
                      <div className="p-4">
                        <h3 className="font-serif font-bold text-gray-900 text-sm md:text-base group-hover:text-pink-500 transition-colors leading-tight">
                          {comic.title}
                        </h3>
                        <div className="mt-2.5 flex items-center justify-between">
                          <span className="text-xs text-gray-500">{comic.category}</span>
                          <span className="flex items-center gap-1 text-xs font-bold text-gray-900">
                            <i className="ri-star-fill text-amber-400" />
                            {comic.rating}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ScrollReveal>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}